import { Component, Input, OnInit } from "@angular/core";
import { EButtonType } from "../../data-types/button.enum";
import { iconsLibrary } from "../../../theme/constants";
import { EInputStyleType } from "../../data-types/input-style.enum";
import { EInputMediaStyleType } from "../../data-types/input-media-style.enum";
import { EDropdownStyleType } from "../../data-types/dropdown-style.enum";
import { CowingInputComponent } from "../shared/cowing-input/cowing-input.component";
import { CowingInputDropdownComponent } from "../shared/cowing-input-dropdown/cowing-input-dropdown.component";
import { CowingInputMediaComponent } from "../shared/cowing-input-media/cowing-input-media.component";
import {
  ISpace,
  ISpaceType,
  IPriceType,
} from "../../data-types/space.interface";
import { ControlContainer, FormGroup } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { FormArray } from "@angular/forms";
import { CoworkingService } from "../../services/coworking.service";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { Router } from "@angular/router";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { Store } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";

@Component({
  selector: "cowing-core-coworking-spaces",
  templateUrl: "./coworking-spaces.component.html",
  styleUrls: ["./coworking-spaces.component.scss"],
})
export class CoworkingSpacesComponent implements OnInit {
  @Input("form") form: FormArray;
  public EInputStyleType = EInputStyleType;
  public EDropdownStyleType = EDropdownStyleType;
  public EInputMediaStyleType = EInputMediaStyleType;
  public EButtonType = EButtonType;
  public spaces: Array<ISpace> = [];
  public spacesType: Array<ISpaceType> = [];
  public stateId: number = 7
  private _spacesToDelete: Array<FormGroup> = [];

  constructor(
    private coworkingService: CoworkingService,
    private router: Router,
    private _store: Store<IAppState>
  ) {}

  async ngOnInit() {
    this._store.dispatch(showLoadingAction({}));
    const coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
    if (coworkingId && this.isEditingInfo) {
      const response = await this.coworkingService.getCoworkingSpaces(
        coworkingId
      );
      this.form.removeAt(0);
      response.forEach((element) => {
        if (element.status > 0) {
          this.addSpace(element);
        }
      });
      this.form.markAllAsTouched();
    }
    this.coworkingService
      .getSpaceTypes()
      .then((spaceTypes: Array<ISpaceType>) => {
        this.spacesType = spaceTypes;
      })
      .catch((e: any) => {
        console.error("Error getting space types");
      });

    this.coworkingService
      .getPriceTypes()
      .then((priceTypes: Array<IPriceType>) => {
        // TODO: Add deurations dynamically
      })
      .catch((e: any) => {
        console.error("Error getting price types");
      });
    this._store.dispatch(closeLoadingAction({}));
  }

  public cleanControl(i, index) {
    if (LocalStorageService.instance.get(EStorageType.Token) !== null) {
      this._spacesToDelete.push(i);
    }
    this.form.removeAt(index);
    this.form.markAsDirty();
  }

  public get getCloseSvg() {
    return `${iconsLibrary.closeSvg}`;
  }
  private getPrivatePrice(space, label) {
    // console.log(space.durations.find((duration) => duration.label === label));
    return space.durations.find((duration) => duration.label === label)
      .private_price;
  }

  addSpace(space?) {
    console.log(space);
    const newGroup = new FormGroup({
      imagePath: new FormControl(space?.thumb || null, [Validators.required]),
      name: new FormControl(space?.name, [Validators.required]),
      spaceCategory: new FormControl(
        space ? { value: space?.type_id, disabled: true } : null,
        [Validators.required]
      ),
      capacity: new FormControl(space?.capacity, [Validators.required]),
      quantity: new FormControl(space?.quantity, [Validators.required]),
      price_hour: new FormControl(
        space
          ? { value: this.getPrivatePrice(space, "price_hour"), disabled: true }
          : null,
        [Validators.required]
      ),
      price_day: new FormControl(
        space
          ? { value: this.getPrivatePrice(space, "price_day"), disabled: true }
          : null,
        [Validators.required]
      ),
      price_week: new FormControl(
        space
          ? { value: this.getPrivatePrice(space, "price_week"), disabled: true }
          : null,
        [Validators.required]
      ),
      price_month: new FormControl(
        space
          ? {
              value: this.getPrivatePrice(space, "price_month"),
              disabled: true,
            }
          : null,
        [Validators.required]
      ),
    });
    space && newGroup.setControl("id", new FormControl(space.id));
    this.form.push(newGroup);
  }
  public goBack() {
    this.router.navigate(["coworking-home"]);
  }
  public get isEditingInfo() {
    return this.router.url === "/coworking-spaces" ? true : false;
  }
  public get isDisabledForm() {
    // console.log(this.form);
    return this.form.dirty && this.form.valid ? false : true;
  }
  public async modifySpaces() {
    this._store.dispatch(showLoadingAction({}));
    const spacesToModify: Array<any> = [];
    const spacesToCreate: Array<any> = [];
    for (let space of this.form.value) {
      let newSpace = { ...space };

      // delete newSpace.capacity;
      if (!space.id) {
        newSpace.type_id = newSpace.spaceCategory.id;
        // newSpace.price_half_day = 0;
        delete newSpace.spaceCategory;

        spacesToCreate.push(newSpace);
      } else {
        spacesToModify.push(newSpace);
      }
    }

    if (spacesToCreate.length) {
      for (let i = 0; i < spacesToCreate.length; i++) {
        const space = spacesToCreate[i];
        let img = spacesToCreate[i].imagePath;
        delete spacesToCreate[i].imagePath;
        const spaceAdded = await this.coworkingService.addSpaces(
          space,
          LocalStorageService.instance.get(EStorageType.ActiveCoworking)
        );

        let spaceImageFormData = new FormData();
        spaceImageFormData.append("file", img);
        const spaceImageAdded = await this.coworkingService.addSpaceImage(
          spaceImageFormData,
          spaceAdded.id
        );
      }
    }
    if (spacesToModify.length) {
      const spaceModified = await this.coworkingService.putSpaces({
        spaces: spacesToModify,
      });
      for (let i = 0; i < spacesToModify.length; i++) {
        if (typeof spacesToModify[i].imagePath != "string") {
          let spaceImageFormData = new FormData();
          spaceImageFormData.append("file", spacesToModify[i].imagePath);
          const spaceImageModified = await this.coworkingService.addSpaceImage(
            spaceImageFormData,
            spacesToModify[i].id
          );
        }
      }
    }

    if (this._spacesToDelete.length) {
      for (let i = 0; i < this._spacesToDelete.length; i++) {
        CoworkingService.instance
          .deleteSpace(this._spacesToDelete[i].controls.id.value, this.stateId)
          .then(() => {
            this.form.removeAt(i);
          })
          .catch((err: any) => {});
      }
    }
    this._store.dispatch(closeLoadingAction({}));
    this.goBack();
    // }
  }
}
